export default {"src":"/_next/static/media/sticker-3.f47ff3cb.svg","height":195,"width":195,"blurWidth":0,"blurHeight":0};